import React from 'react';
import LearningPlanStatus from '../../../../model/LearningPlanStatus';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';
const LearningPlanStatusSelector = ({ title, omitCompleted = false, ...props }) => {
    const _title = useLabel('Status', title);
    const { options } = useEnumerableModel(omitCompleted
        ? {
            ...LearningPlanStatus,
            Basic: LearningPlanStatus.BasicWithoutCompleted,
        }
        : LearningPlanStatus);
    return (<MultiselectFilter itemId={itemIdValue} options={options} title={_title} {...props}/>);
};
export default LearningPlanStatusSelector;
